import classNames from "classnames";
import { useEventTheming } from "state/AppThemingContext";

type Props = {
  name: string;
  style?: "solid" | "regular" | "light" | "duotone";
  isSharp?: boolean;
  size?: "xs" | "sm" | "lg" | "xl" | "2x" | "3x" | "5x" | "7x" | "10x";
  className?: string;
};

const FontAwesomeIcon: React.FC<Props> = ({
  name,
  size,
  className,
  ...props
}) => {
  const { theming } = useEventTheming()
  const iconStyle = theming?.icon_style;
  const iconFill = theming?.icons_filled;

  const style = props.style
    ? `fa-${props.style}`
    : iconFill
      ? "fa-solid"
      : "fa-light";

  const isSharp =
    props.isSharp !== undefined ? props.isSharp : iconStyle === "sharp";

  const isClassic = iconStyle === "classic";

  const isDirectional = name.includes("left") || name.includes("right");

  return (
    <i
      className={classNames(`${name}`, style, className, {
        "fa-sharp": isSharp,
        "fa-classic": isClassic,
        [`fa-${size}`]: size,
        "rtl:-scale-x-100": isDirectional,
      })}
    />
  );
};

export default FontAwesomeIcon;
